var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-tree',{ref:"tree",staticClass:"FormTree",class:[_vm.maxDeep > 3 ? 'deep4' : 'deep3'],attrs:{"data":_vm.treeList,"node-key":_vm.nodeKey,"show-checkbox":"","props":{ label: 'display_name' },"check-strictly":_vm.checkStrictly}})
}
var staticRenderFns = []

export { render, staticRenderFns }